import React, { useEffect } from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useDispatch } from 'react-redux';

import { apiClient } from '@/http-client';
import { formatPostData } from '@services/postService';
import { reqUsedCollectionAction } from '@stores/used/actions';
import { PageContext } from '@contexts';
import { DefaultPage } from '@containers';

const UsedProducts = (data) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(reqUsedCollectionAction());
  }, []);

  return (
    <PageContext.Provider value={data?.data}>
      <DefaultPage />
    </PageContext.Provider>
  );
};

export const getServerSideProps = async ({ locale }) => {
  try {
    const { data: post } = await apiClient.get('/api/Posts/byTitle/used');

    const data = formatPostData(post);

    const checkTheme = data?.DisplayOptions?.find((x) => x.Name == 'Header')?.DisplayOptions?.find(
      (item) => item.DisplayOptionKey == 'DarkMode'
    )?.Enabled;

    data.DarkMode = checkTheme ? checkTheme : null;

    if (!data) {
      return {
        notFound: true,
        redirect: {
          permanent: true,
          destination: '/404'
        }
      };
    }

    const translations = await serverSideTranslations(locale, ['common', 'footer']);

    return {
      props: {
        data,
        ...translations
      }
      /**
       * Caches page and regenerates page in 60 second windows.
       * Note: might be good to bump this number up when site goes live.
       */
    };
  } catch (error) {
    throw new Error(`Error fetching used products: ${error?.message}`);
  }
};

export default UsedProducts;
